import { render, staticRenderFns } from "./artificial-service.vue?vue&type=template&id=cf4116da&scoped=true&"
import script from "./artificial-service.vue?vue&type=script&lang=js&"
export * from "./artificial-service.vue?vue&type=script&lang=js&"
import style0 from "./artificial-service.vue?vue&type=style&index=0&id=cf4116da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4116da",
  null
  
)

export default component.exports